import {
  getReceiptList,
  pathActiveReceipt,
  pathDeactiveReceipt,
  pathReDeactiveReceipt,
  pathReactiveReceipt,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { receiptActions } from "../reducers/receipt";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchReceiptList = (id_receipt = 0) => {
  return (dispatch) => {
    return apiService
      .get(getReceiptList(id_receipt))
      .then((response) => {
        id_receipt == 0
          ? dispatch(receiptActions.fetchReceiptList(response.data))
          : dispatch(receiptActions.fetchReceiptDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchActiveReceipt = (id = 0, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathActiveReceipt(id))
      .then((response) => {
        navigate("/order");
        toast.success(t("receiptsListActions.accept"), {
          theme: "colored",
        });
        dispatch(fetchReceiptList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReactiveReceipt = (id = 0, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathReactiveReceipt(id))
      .then((response) => {
        navigate("/order");
        toast.success(t("receiptsListActions.accept"), {
          theme: "colored",
        });
        dispatch(fetchReceiptList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeactiveReceipt = (id = 0, rejectReason, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathDeactiveReceipt(id), rejectReason)
      .then((response) => {
        navigate("/order");
        toast.success(t("receiptsListActions.reject"), {
          theme: "colored",
        });
        dispatch(fetchReceiptList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReRejectReceipt = (id = 0, rejectReason, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathReDeactiveReceipt(id), rejectReason)
      .then((response) => {
        navigate("/order");
        toast.success(t("receiptsListActions.reject"), {
          theme: "colored",
        });
        dispatch(fetchReceiptList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
